function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const nodeFetch = require("node-fetch");
const { parseSocialTitle, parseSocialDescription } = require("./comeet-parsing-service");
const { trackBigBrainEventOnServer } = require("../bigbrain-tracking-service/bigbrain-tracking-service");
const { CAREER_POSITIONS_RETRIEVE_FROM_COMEET, CAREER_POSITIONS_RETRIEVE_FROM_COMEET_ERROR } = require("../../../constants/bigbrain-event-types");
const { getPublishCategoryValue } = require("./position-type-service");
const { POSITION_TYPE_INTERNAL } = require("../../../components/pages/careers/careers-constants");
const COMEET_COMPANY_UID = "41.00B"; // Used also in client side - fix
const COMEET_END_POINT = `https://www.comeet.co/careers-api/2.0/company/${COMEET_COMPANY_UID}/positions`;
const EXTERNAL_ABOUT_THE_ROLE_FIELD_NAME = "About The Role";
const INTERNAL_ABOUT_THE_ROLE_FIELD_NAME = "About The Team (Internal)";
const EXTERNAL_REQUIRMENTS_NAME = "Requirements";
const INTERNAL_REQUIRMENTS_NAME = "Internal requirements";
let COMEET_TOKEN;
const createApplicationFormWidget = ()=>{
    //only intilized comeet widget once
    if (window.comeetInit) return;
    //this is the way to create the form
    //and social widget from comeet api
    //according to 7/12/2017
    window.comeetInit = function() {
        COMEET.init({
            token: COMEET_TOKEN,
            "require-profile": "any",
            "css-cache": "false",
            "company-uid": COMEET_COMPANY_UID,
            "company-name": "monday",
            "font-size": "13px",
            "labels-position": "top",
            "field-coverletter": "false",
            "field-website": "false",
            "field-portfolio": "false",
            "field-personalnote": "false",
            "field-linkedin": "true",
            "social-show-title": "false",
            "social-employees": "true",
            "social-color": "white",
            "social-networks": "extended",
            "button-color": "00a9ff",
            "button-text": "Send my application",
            "button-font-size": "16px"
        });
    };
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//www.comeet.co/careers-api/api.js";
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "comeet-jsapi");
};
const getCityFromLocation = (location)=>{
    var _location_name_toLowerCase, _location_name;
    // exclude remote locations
    if (location === null || location === void 0 ? void 0 : (_location_name = location.name) === null || _location_name === void 0 ? void 0 : (_location_name_toLowerCase = _location_name.toLowerCase()) === null || _location_name_toLowerCase === void 0 ? void 0 : _location_name_toLowerCase.includes("remote")) {
        return location.name;
    }
    const { city } = location || {};
    return city;
};
const getDepartmentToPositionMapping = (data)=>{
    //If comeet returns an error dont break the page
    if (data.status === 400) {
        data = [];
    }
    let result = {};
    let ans = [];
    data.forEach((element)=>{
        const { department, name, location, uid } = element;
        const city = getCityFromLocation(location);
        if (!result[department]) result[department] = [];
        result[department].push({
            name,
            city,
            uid
        });
    });
    Object.keys(result).forEach((key)=>{
        if (key != "Unlisted") ans.push({
            name: key,
            jobs: result[key]
        });
    });
    return ans;
};
const getPositionDetailsByID = function() {
    var _ref = _async_to_generator(function*(positionId, positionsType) {
        const position = yield getDataFromComeet(positionId);
        if (position && ![
            400,
            404
        ].includes(position.status)) {
            // Currently checking 400 and 404 specificaly
            const { name, location, details, department, employment_type: employmentType } = position;
            const city = getCityFromLocation(location);
            const getComeetDetailsFieldByName = (cmtDetails, fieldName)=>{
                const result = cmtDetails ? cmtDetails.find((x)=>x.name == fieldName) : null;
                return result || {};
            };
            let aboutTheRoleFieldName = EXTERNAL_ABOUT_THE_ROLE_FIELD_NAME;
            let requirementsFieldName = EXTERNAL_REQUIRMENTS_NAME;
            if (positionsType === POSITION_TYPE_INTERNAL) {
                aboutTheRoleFieldName = INTERNAL_ABOUT_THE_ROLE_FIELD_NAME;
                requirementsFieldName = INTERNAL_REQUIRMENTS_NAME;
            }
            const description = getComeetDetailsFieldByName(details, "Description").value;
            const responsibilities = getComeetDetailsFieldByName(details, aboutTheRoleFieldName).value;
            const requirements = getComeetDetailsFieldByName(details, requirementsFieldName).value;
            const socialTitle = parseSocialTitle(getComeetDetailsFieldByName(details, "Social Title"));
            const socialDescription = parseSocialDescription(getComeetDetailsFieldByName(details, "Social Description"));
            const comeetFieldTeamDesc = getComeetDetailsFieldByName(details, "Our Team");
            const teamDescription = comeetFieldTeamDesc ? comeetFieldTeamDesc.value : "";
            const positionTypeValue = getPublishCategoryValue(position);
            return {
                department,
                title: name,
                location: city,
                positionDescription: description,
                positionRequirements: requirements,
                positionResponsibilities: responsibilities,
                socialTitle,
                socialDescription,
                //DZ 5may20: added for new careers page:
                employmentType,
                teamDescription,
                positionTypeValue
            };
        }
        trackBigBrainEventOnServer(CAREER_POSITIONS_RETRIEVE_FROM_COMEET_ERROR, {
            kind: positionId,
            info1: position === null || position === void 0 ? void 0 : position.status,
            info2: position === null || position === void 0 ? void 0 : position.message
        });
        return {
            ERROR: `POSITION ${positionId} NOT FOUND`,
            status: position === null || position === void 0 ? void 0 : position.status,
            message: position === null || position === void 0 ? void 0 : position.message
        };
    });
    return function getPositionDetailsByID(positionId, positionsType) {
        return _ref.apply(this, arguments);
    };
}();
// http://support.comeet.co/knowledgebase/careers-api/
const getDataFromComeet = function() {
    var _ref = _async_to_generator(function*(positionId = null) {
        const { get } = require("../../../secrets-service");
        const { api_token: COMEET_TOKEN } = yield get("comeet");
        const COMEET_PARAMS = `?token=${COMEET_TOKEN}&details=true`;
        const url = positionId ? `${COMEET_END_POINT}/${positionId}${COMEET_PARAMS}` : `${COMEET_END_POINT}${COMEET_PARAMS}`;
        const options = {
            insecureHTTPParser: true
        };
        trackBigBrainEventOnServer(CAREER_POSITIONS_RETRIEVE_FROM_COMEET, {
            kind: positionId ? "single_position" : "all_positions",
            info1: positionId
        });
        const response = yield nodeFetch(url, options);
        const data = yield response.json();
        return data;
    });
    return function getDataFromComeet() {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getDataFromComeet,
    getDepartmentToPositionMapping,
    getPositionDetailsByID,
    createApplicationFormWidget
};
